// extracted by mini-css-extract-plugin
export default {"p":"c0a4aaa602 e9d9265436 _6da228e9d4","clr":"e0b5da48d8","dls":"baf2e3338a"};